import React, { Component } from "react";
import { Tag, ControlGroup } from "@blueprintjs/core";
import { inject, observer } from "mobx-react";
import SingleSelectWrapper from "../utils/SingleSelectWrapper";
import BranchService from "../services/BranchService";
import cogoToast from "cogo-toast";

/**
 * Reusable component for selecting branches
 * Automatically loads branches for the authenticated user's organization
 */
class BranchSelector extends Component {
  state = {
    branches: [],
    loading: false,
    error: null,
  };

  componentDidMount() {
    this.loadBranches();
  }

  componentDidUpdate(prevProps) {
    // Reload branches if the user's prefix changes
    if (prevProps.authStore.prefix !== this.props.authStore.prefix) {
      this.loadBranches();
    }
  }

  loadBranches = async () => {
    if (!this.props.authStore.prefix) return;

    try {
      this.setState({ loading: true, error: null });
      const branchNames = await BranchService.getBranchNames(this.props.authStore.prefix);
      this.setState({
        branches: branchNames,
        loading: false,
      });
    } catch (err) {
      this.setState({
        error: err,
        loading: false,
        branches: [],
      });
    }
  };

  render() {
    const {
      selectedBranch,
      onBranchChange,
      disabled = false,
      placeholder = "Select branch...",
      label = "Branch",
      showLabel = true,
    } = this.props;
    const { branches, loading, error } = this.state;

    if (loading) {
      return (
        <ControlGroup>
          {showLabel && (
            <Tag large minimal>
              {label}
            </Tag>
          )}
          <Tag>Loading branches...</Tag>
        </ControlGroup>
      );
    }

    if (error) {
      return (
        <ControlGroup>
          {showLabel && (
            <Tag large minimal>
              {label}
            </Tag>
          )}
          <Tag intent="danger">Failed to load branches</Tag>
        </ControlGroup>
      );
    }

    if (!branches.length) {
      return (
        <ControlGroup>
          {showLabel && (
            <Tag large minimal>
              {label}
            </Tag>
          )}
          <Tag intent="warning">No branches available</Tag>
        </ControlGroup>
      );
    }

    const itemsWithAll = ["All Branches", ...branches];
    const handleChange = (val) => {
      if (typeof onBranchChange === "function") {
        if (val === "All Branches" || val === "All") {
          onBranchChange("");
        } else {
          onBranchChange(val);
        }
      }
    };

    return (
      <ControlGroup>
        {showLabel && (
          <Tag large minimal>
            {label}
          </Tag>
        )}
        <SingleSelectWrapper
          items={itemsWithAll}
          showSelectProp={true}
          selectedItem={selectedBranch ? selectedBranch : "All Branches"}
          onChange={handleChange}
          disabled={disabled}
          placeholder={placeholder}
        />
      </ControlGroup>
    );
  }
}

export default inject("authStore")(observer(BranchSelector));
